import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { findIndex, get } from 'lodash';

import { openModal } from 'store/v1/ui/ui.actions.js';
import { DialogClose } from 'v5/design-system/Dialog.js';
import { Button } from 'v5/design-system/Button.js';
import { Maximize2 } from 'lucide-react';
import {
  ComboboxCreateItem,
  ComboboxCreateItemQuery
} from 'v5/design-system/Combobox.js';
import { getDefaultResourceType } from 'store/v1/contacts/contacts.selectors.js';
import { createNameFromString } from 'v1/helpers/contactHelpers.jsx';
import { createContact } from 'store/v1/contacts/contacts.actions.js';

const BookResourceFlyoverResourceFooter = ({
  slot,
  resourceTypeId,
  onResourceAssign
}) => {
  const dispatch = useDispatch();

  const productions = useSelector(state => state.productions.data);
  const production = get(productions, [slot.production_id], {});

  const openBlackbookModal = () => {
    // TODO: ripped out of ProductionBudgetTableTeamCommitted
    const data = {
      destination: 'PRODUCTION_TEAM_MEMBER_OPTIONS',
      store: 'productions',
      initialQuery: slot.query || {},
      dataPointers: [
        {
          label: 'production',
          pointTo: ['productions', 'data', production.id]
        },
        {
          label: 'resource_slot',
          pointTo: [
            'productions',
            'data',
            production.id,
            'resource_slots',
            findIndex(production.resource_slots, r => r.id === slot.id)
          ]
        }
      ],
      production,
      actions: ['PRODUCTION_BOOK_RESOURCE_SLOT']
    };
    dispatch(openModal('AddFromBlackbookModal', data));
  };

  const resourceTypes = useSelector(state => state.resource_types.data);
  const defaultResourceType = useSelector(getDefaultResourceType);
  const activeResourceTypeId = resourceTypeId || defaultResourceType?.id;
  const activeResourceType = get(resourceTypes, activeResourceTypeId);

  // TODO: this is ripped out of ResourceSelector
  const onCreateResource = async query => {
    const { first_name, last_name } = createNameFromString(query);
    const toSubmit = {
      first_name,
      last_name,
      resource_type_id: activeResourceTypeId
    };
    const {
      result: { id }
    } = await dispatch(createContact(toSubmit, null));
    onResourceAssign(id);
  };

  return (
    <div className="w-full">
      <ComboboxCreateItem
        size="lg"
        className="*:*:py-3 *:px-1 *:*:px-4 sticky bottom-0 bg-white mb-1.5"
        onSelect={onCreateResource}
      >
        Create & assign "<ComboboxCreateItemQuery />" as a new{' '}
        <div className="inline-block break-inside-avoid text-brand-500 font-bold">
          {activeResourceType ? activeResourceType.name : 'resource'}
        </div>
      </ComboboxCreateItem>
      <DialogClose
        asChild
        className="w-full justify-between"
        onClick={openBlackbookModal}
      >
        <Button variant="ghost" size="md">
          Open full search
          <Maximize2 />
        </Button>
      </DialogClose>
    </div>
  );
};

BookResourceFlyoverResourceFooter.propTypes = {
  slot: PropTypes.object
};

export default BookResourceFlyoverResourceFooter;
